import { useQuery } from '@tanstack/react-query';

import { getSummaryData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

function useContractSummaryData(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractSummaryData', contractId],
    queryFn: () => getSummaryData(apiHost, contractId),
  });

  return query;
}

export default useContractSummaryData;
